var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"system-choice-control",class:_vm.checked ? 'checked' : ''},[_c('input',{staticClass:"system-choice-input",attrs:{"type":_vm.type,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change')}}}),_c('span',{staticClass:"system-choice-indicator"})])
}
var staticRenderFns = []

export { render, staticRenderFns }